export default __webpack_public_path__ + "static/media/image-placeholder-rect.0421e4d5.svg";